var render = function render(){var _vm=this,_c=_vm._self._c;return _c('widget-settings-item',{attrs:{"title":_vm.title,"disabled":_vm.disabled,"hide-on-disabled":""}},[_c('c-storage-field',_vm._g({attrs:{"required":_vm.required,"disabled":_vm.disabled},model:{value:(_vm.storage),callback:function ($$v, $$p) {_vm.$updateField([], $$v, undefined)},expression:"storage"}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }